import React from 'react'

import { Placement } from '@popperjs/core'

import { Box, Dropdown, Icon, IconButton } from 'stardust'
import styled from 'styled-components'

import { DropdownMenuItem, DropdownMenuItemProps } from '~/components/DropdownMenu'
import { isHomeWebview } from '~/config'
import { ICON_BUTTON_SIZES } from '~/theme'
import colors from '~/ui-components/tokens/colors'

interface Props {
  items: DropdownMenuItemProps[]
  iconSize?: number | string
  iconButtonSize?: string
  placement?: Placement
  backdrop?: boolean
}

const StyledButton = styled(IconButton)<{ backdrop?: boolean; size?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: ${(props) => props.size || ICON_BUTTON_SIZES.md};
  height: ${(props) => props.size || ICON_BUTTON_SIZES.md};
  background-color: ${(props) => (props.backdrop ? colors.cosmicShade3 : 'transparent')};
`

const OverflowMenu = ({ items, iconSize, iconButtonSize, placement, backdrop }: Props) => (
  <Box cursor="pointer" data-test="overflow-menu">
    <Dropdown
      placement={placement}
      renderButton={({ handleClose }) => (
        <StyledButton
          backdrop={backdrop}
          size={iconButtonSize}
          onClick={handleClose}
          icon={
            <Icon
              name="overflow"
              fill={isHomeWebview ? colors.cosmicShade0 : colors.cosmicShade15}
              width={iconSize}
            />
          }
          aria-hidden="false"
          aria-label="more-options"
        />
      )}
      render={({ handleClose }) =>
        items.map((item) => {
          const onClick = () => {
            handleClose()
            item.onClick()
          }

          return <DropdownMenuItem key={item.label} label={item.label} icon={item.icon} onClick={onClick} />
        })
      }
    />
  </Box>
)

OverflowMenu.displayName = 'OverflowMenu'

export default React.memo(OverflowMenu)
